module.exports = __webpack_public_path__ + "img/certificate_bg2.6aabdbe1.png";